<template>
  <div class="edit-service-form-card">
    <h3 class="card-title">Editing Service: {{ localService.name }}</h3>
    <p class="form-instruction">Modify the details, pricing, duration, and image as needed.</p>

    <form @submit.prevent="submitUpdate" class="service-form-grid">

      <div 
        class="form-group image-dropzone"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @drop.prevent="handleDrop"
        :class="{ 'dragging': isDragging }"
        @click="triggerFileInput"
      >
        <input type="file" ref="fileInput" @change="handleFileChange" style="display: none" accept="image/*">
        <p v-if="!imageFileName">
          <span class="upload-icon">🖼️</span> Drag & Drop Picture Here or Click to Upload
        </p>
        <p v-else class="uploaded-filename">
          ✅ Current file: **{{ imageFileName }}**
        </p>
      </div>

      <div class="form-column details-column">
        
        <div class="form-group">
          <label for="service-name">Service Name</label>
          <input type="text" id="service-name" v-model="localService.name" required> <!-- Adjusted localService-->
        </div>

        <div class="form-group price-group">
          <label for="service-price">Price ($)</label>
          <input type="text" id="service-price" v-model="localService.price" required placeholder="50.00">
        </div>
        
        <div class="form-group duration-group">
            <label for="service-duration">Duration (Minutes)</label>
            <input 
                type="number" 
                id="service-duration" 
                v-model.number="localService.duration" 
                required 
                min="15" 
                step="5"
                placeholder="60"
            > 
            <!-- Fixed localService.duration -->
            <small class="input-note">Minimum duration is 15 minutes.</small>
        </div>

      </div>

      <div class="form-column description-column">
        
        <div class="form-group category-group">
          <label for="service-category">Category</label>
          <select id="service-category" v-model="category" required>
            <option value="hair">Hair</option>
            <option value="nails">Nails</option>
            <option value="skin">Skin</option>
            <option value="misc">Miscellaneous</option>
          </select>
        </div>

        <div class="form-group full-height description-group">
          <label for="service-description">Description</label>
          <textarea id="service-description" v-model="localService.description" required rows="7"></textarea>
        </div>

      </div>
      
      <div class="action-buttons full-width">
        <button type="button" class="btn-cancel" @click="$emit('cancel')">Cancel</button>
        <button type="submit" class="btn-submit btn-update">Update Service</button>
      </div>
    </form>
  </div>
</template>

<script>
//import axios from 'axios' //importing to manage the images
export default {
    name: 'EditService',
    emits: ['update-service', 'cancel'],
    props: {
       service: { 
            type: Object,
            required: true
        }
        /*
        {
    "description": "Has",
    "duration": 25,
    "id": 2,
    "image": "Screen_Shot_2025-08-02_at_00.13.25.png",
    "name": "Buid",
    "price": 60
}*/
    },
    data() {
        return {
            category : "",
            localService: { 
                ...this.service, 
                // duration_minutes: this.service.duration || null 
            },
            
            imageFileName: this.service.image, //name of image
            imageFilePath: this.getImageUrl(this.imageFileName), //url to image src
            imageFile: null, 
            isDragging: false,
        };
    },
    mounted () {
                try {
        } catch(error) {
            console.log("Error in prop data")
            console.log(error)
        }
        console.log(this.service)
    },
    created () {
        try {
            console.log(this.service)
        } catch(error) {
            console.log("Error in prop data")
            console.log(error)
        }
        console.log(this.service)
    },
    watch: {
        service: {
            handler(newService) {
                this.localService = { ...newService,} // duration_minutes: localService.newService.duration_minutes || null };
                this.imageFile = null
                this.imageFileName = newService.image
            },
            deep: true // Watch for nested changes if the service object itself mutates
        }
    },
    methods: {
        getImageUrl(filename) {
            const API_BASE = 'http://127.0.0.1:5000'; 
            return `${API_BASE}/uploads/services/${filename}`;
        },

        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.imageFile = file
                this.imageFileName = file.name;
                this.isDragging = false;
            }
        },
        handleDrop(event) {
            this.isDragging = false;
            const file = event.dataTransfer.files[0];
            if (file && file.type.startsWith('image/')) {
                this.imageFile = file
                this.imageFileName = file.name;
            }
        },

        // --- Submission ---
        submitUpdate() {
            if (!this.imageFileName) {
                alert("Please ensure an image file is specified.");
                return;
            }
            if (!this.localService.duration || this.localService.duration < 15) {
                alert("Please specify a duration of 15 minutes or more.");
                return;
            }
            //Prepare service data
            const serviceData = {
                ...this.localService,
                imageFile: this.imageFile, 
                originalImageFileName: this.service.image
            }

            console.log("The service data to be emited is ", serviceData)


            // 2. Emit the complete updated service object
            this.$emit('update-service', serviceData);
        }
    }
}
</script>


<style scoped>

.edit-service-form-card {
    background-color: white;
    padding: 35px;
    border-radius: 12px; 
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    border: 2px solid var(--color-earth); /* Earth tone border for 'editing' feel */
    font-family: 'Inter', sans-serif;
}

.card-title {
    color: var(--color-update-btn); /* Blue title for edit form */
    font-size: 2.2rem;
    font-family: 'Playfair Display', serif;
    margin-bottom: 5px;
}

.form-instruction {
    color: #555;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid var(--color-gold); /* Gold separator */
}

/* Form Layout: Image-First Grid */
.service-form-grid {
    display: grid;
    gap: 25px; 
    grid-template-columns: 1fr; 
}

/* The Image Dropzone must span the entire width */
.image-dropzone {
    grid-column: 1 / -1; 
}

@media (min-width: 800px) {
    .service-form-grid {
        /* Define 2 columns for the content below the image */
        grid-template-columns: 1fr 1fr; 
    }
    
    /* Ensure the image and buttons still span both columns */
    .image-dropzone,
    .action-buttons {
        grid-column: span 2; 
    }
}

.form-column {
    display: flex;
    flex-direction: column;
    gap: 20px; 
    padding: 0;
}

.form-group {
    display: flex;
    flex-direction: column;
    width: 100%; 
}

.form-group label {
    font-weight: 700;
    color: var(--color-maroon); 
    margin-bottom: 8px;
    font-size: 1.05rem;
}

.form-group input, .form-group select, .form-group textarea {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    width: 100%;
    box-sizing: border-box;
    transition: border-color 0.3s, box-shadow 0.3s;
}

.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
    border-color: var(--color-earth); 
    box-shadow: 0 0 0 2px rgba(160, 82, 45, 0.2);
    outline: none;
}

/* Specific Field Adjustments */
.description-group {
    flex-grow: 1;
}
.description-group textarea {
    flex-grow: 1;
    min-height: 150px;
}
.input-note {
    font-size: 0.8em;
    color: #999;
    margin-top: 5px;
    display: block;
}

/*Image Dropzone Styling */
.image-dropzone {
    text-align: center;
    border: 4px dashed var(--color-earth); /* Stronger Earth tone border */
    border-radius: 10px;
    padding: 40px 20px;
    cursor: pointer;
    transition: background-color 0.3s, border-color 0.3s;
    margin-bottom: 25px; /* Separate from fields below */
}

.image-dropzone:hover, .image-dropzone.dragging {
    background-color: #fffaf0; 
    border-color: var(--color-maroon);
}

.upload-icon {
    display: block;
    font-size: 3rem; 
    margin-bottom: 10px;
}

.uploaded-filename {
    color: var(--color-maroon);
    font-weight: 700;
    font-size: 1.1rem;
}

.upload-note {
    color: #777;
    margin-top: 10px;
}

/*  Action Buttons */
.action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 15px;
    margin-top: 20px;
    padding-top: 25px;
    border-top: 1px solid #eee;
}

.btn-cancel, .btn-submit {
    padding: 12px 25px;
    border: none;
    border-radius: 25px; 
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-cancel {
    background-color: #999; 
    color: white;
}

.btn-cancel:hover {
    background-color: #777;
    transform: translateY(-1px);
}

.btn-submit {
    background-color: var(--color-maroon);
    color: white;
}

.btn-update {
    background-color: #1E88E5; 
}

.btn-update:hover {
    background-color: #1565C0; 
    transform: translateY(-1px);
}
</style>